import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Tasks: React.FC<BaseIconProps> = React.forwardRef(
  ({ size = 'md', color = 'default', className }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9999 1L5.85704 9.65076L2.99988 6.86019"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2858 6.58169V12.4419C11.2858 12.7501 11.0299 13 10.7144 13H1.57143C1.25584 13 1 12.7501 1 12.4419V3.51206C1 3.20382 1.25584 2.95395 1.57143 2.95395H8.14291"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default Tasks
